import Script from 'next/script';

import { publicEnvConfig } from 'config/public';
import { useMarketCode } from 'hooks';
import { cn } from 'utils/classNames';

interface Props {
	className?: string;
}

/** Trygg e-handel certificate logo. */
export default function TryggEhandel({ className }: Props) {
	const market = useMarketCode();
	if (market !== 'SE') {
		return null;
	}
	const id =
		publicEnvConfig.ENVIRONMENT_TYPE === 'production'
			? '65b300ba-27b9-4f27-8e21-ef263317dab7'
			: 'demo';

	return (
		<>
			<div
				className={cn(
					// Required by the script.
					'teh-certificate',
					// The script renders an inline-block element, set alignment
					// to prevent baseline spacing below it.
					'*:align-top',
					className,
				)}
				data-size="60"
			/>
			<Script
				id="tryggehandel-script"
				src={`https://cert.tryggehandel.net/js/script.js?id=${id}`}
				strategy="lazyOnload"
			/>
		</>
	);
}
TryggEhandel.displayName = 'TryggEhandel';
